// import { Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
// import moment from 'moment'
// import React from 'react'
// import DeleteIcon from '@mui/icons-material/Delete';

// const CategoryMenu = () => {
//     return (
//         <Grid className="product__page">
//             <TableContainer component={Paper}>
//                 <Table sx={{ minWidth: 650 }} aria-label="simple table">
//                     <TableHead>
//                         <TableRow>
//                             {['Category', 'Is Active', 'Created At', 'Action'].map((header) => (
//                                 <TableCell key={header} style={{ fontWeight: 'bold' }} align="left">{header}</TableCell>
//                             ))}
//                         </TableRow>
//                     </TableHead>
//                     <TableBody>
//                         {[].map((row) => (
//                             <TableRow key={row.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
//                                 <TableCell align="left">{row.batch_number}</TableCell>
//                                 <TableCell align="left">{row.mrp}</TableCell>
//                                 <TableCell align="left">{row.version}</TableCell>
//                                 <TableCell align="left">{moment(row.createdAt).format('LLL')}</TableCell>
//                                 {/* <TableCell align="left">
//                                     <IconButton onClick={() => { setDeleteConfirm(true); setDeleteId(row.id); }}>
//                                         <DeleteIcon />
//                                     </IconButton>
//                                 </TableCell> */}
//                             </TableRow>
//                         ))}
//                     </TableBody>
//                 </Table>
//             </TableContainer>
//         </Grid>
//     )
// }

// export default CategoryMenu

import {
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  useMediaQuery,
  useTheme,
  Typography,
} from '@mui/material';
import moment from 'moment';
import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';

const CategoryMenu = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const categoryList = []; // Replace with real data when integrating

  return (
    <Grid container spacing={2} padding={2}>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Category Menu
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Box sx={{ overflowX: 'auto' }}>
          <TableContainer component={Paper}>
            <Table size={isSmallScreen ? 'small' : 'medium'}>
              <TableHead>
                <TableRow>
                  {['Category', 'Is Active', 'Created At', 'Action'].map((header) => (
                    <TableCell key={header} sx={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {categoryList.length > 0 ? (
                  categoryList.map((row, idx) => (
                    <TableRow key={idx}>
                      <TableCell>{row.category}</TableCell>
                      <TableCell>{row.isActive ? 'Yes' : 'No'}</TableCell>
                      <TableCell>{moment(row.createdAt).format('LLL')}</TableCell>
                      <TableCell>
                        <IconButton onClick={() => console.log('Delete', row.id)}>
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      No data found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Grid>
    </Grid>
  );
};

export default CategoryMenu;
